import { ListChart, ListChartProps } from '../../../renderers/list-chart/list-chart.component';
import { CONSUMPTION_RATE_BY_PRODUCT_LIST_CHART_DEFINITION } from './consumption-rate-by-product-list-chart.definition';
import { CONSUMPTION_RATE_BY_PRODUCT_LIST_CHART_MOCK_DATA } from './consumption-rate-by-product-list-chart.mock';

export const ConsumptionRateByProductListChart = (props: ListChartProps) => <ListChart {...props} />;

ConsumptionRateByProductListChart.definition = CONSUMPTION_RATE_BY_PRODUCT_LIST_CHART_DEFINITION;
ConsumptionRateByProductListChart.mockData = CONSUMPTION_RATE_BY_PRODUCT_LIST_CHART_MOCK_DATA;
